import React from 'react';

import { Icon } from 'semantic-ui-react';

import _ from 'lodash';
import LongText from '../../../../CBSA_App/util/LongText';
import DynamicTable from './dynamicTable';

export const decamelize = (str, separator) => {
    separator = typeof separator === 'undefined' ? ' ' : separator
    return _.startCase(str)
      .replace(/([a-z\d])([A-Z])/g, '$1' + separator + '$2')
      .replace(/([A-Z]+)([A-Z][a-z\d]+)/g, '$1' + separator + '$2')
  }


export const JSONDisplayer = (children, showErrors) => {
    let copyobject = children
    if(copyobject && typeof copyobject !== "string" && typeof copyobject !== "number"){
    return Object.keys(copyobject).map((kkkkeeey, ix) => {
      if ((kkkkeeey == 'payload' || kkkkeeey == 'error') && !showErrors) return <React.Fragment key={kkkkeeey + 'rhkea' + ix}></React.Fragment>
      return (
        <section
          className='row widthRow clickableJSONobj'
          key={kkkkeeey + 'rhea' + ix}
          style={{ border: '1px solid #ccc', display: 'block' }}
        >
          {Array.isArray(copyobject[kkkkeeey]) && typeof copyobject[kkkkeeey][0] === "object" ? (
            <>
              <div
                style={{
                  paddingLeft: '2px',
                  width: 'fit-content',
                  marginTop: '15px',
                  display: 'block',
                  color: kkkkeeey.toLowerCase().includes("error") ? 'red': "black"
                }}
              >
                <b>
                    {
                      kkkkeeey.toLowerCase().includes("error") && 
                      <Icon name='warning circle' color='red' style={{"display": "inline"}}/>
                    }
                  <u>
                    {decamelize(kkkkeeey)}</u>
                </b>
              </div>
  
              <div style={{ paddingLeft: '2px', width: '100%', marginTop: '15px', display: 'block' }}>
                {<DynamicTable TableData={copyobject[kkkkeeey]} />}
              </div>
            </>
          ) :
          Array.isArray(copyobject[kkkkeeey]) && typeof copyobject[kkkkeeey][0] !== 'object' ? 
          (
            copyobject[kkkkeeey].join(", ")
          ) :
          !Array.isArray(copyobject[kkkkeeey]) && typeof copyobject[kkkkeeey] == 'object' ? (
            <div className='width-16' width={16} style={{ paddingLeft: '2px', width: '100%' }}>
              <b>{!kkkkeeey.match(/^[0-9]+$/g) && decamelize(kkkkeeey)}</b>
              <br />
              <div className='width-16' width={16}>
                {copyobject[kkkkeeey] && JSONDisplayer(copyobject[kkkkeeey])}
              </div>
            </div>
          ) : (
            <>
              <div className='width-4' width={4} style={{ paddingLeft: '2px' }}>
                <b>{decamelize(kkkkeeey)}</b>
                :&nbsp;
              </div>
              <div className='width-12' width={12} style={{ paddingLeft: '2px' }}>
              {
                typeof copyobject[kkkkeeey] === 'string' ? <LongText content = {copyobject[kkkkeeey].replaceAll("/", "/ ")} limit = {100} /> : copyobject[kkkkeeey]
              } 
              </div>
            </>
          )}
        </section>
      )    
    })
    }
    else {
      return (<section
        className='row widthRow clickableJSONobj'
        style={{ display: 'block' }}>
         {
            typeof copyobject === 'string' ? <LongText content = {copyobject.replaceAll("/", "/ ")} limit = {100} /> : copyobject
         } 
      </section>)
    }
    
  }